import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ISeriesStageIndoor, SeriesStageIndoorStore } from '../../../common-page-components/stores/entities-store/series-stage-indoor-store';
import { TableAbstractComponent } from '../../../common-page-components/classes/table-abstract-component';
import { Injector } from '@angular/core';
import { FiltersServiceService } from '../filters-service.service';
@Component({
  selector: 'app-event-indoor',
  templateUrl: './event-indoor.component.html',
  styleUrls: ['./event-indoor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventIndoorComponent extends TableAbstractComponent implements OnInit {
  headers = [
    { name: "", isSortable: false },
    { name: "", isSortable: false },
    { name: "", isSortable: false },
    { name: "", isSortable: false },
    { name: "", isSortable: false },
  ]
  /**
   * Series stage locator
   *
   * @type {ISeriesStageIndoor[]}
   * @memberof EventIndoorComponent
   */
  @Input()
  seriesStage: ISeriesStageIndoor[];

  /**
   * Date for show in the header.
   *
   * @type {Date}
   * @memberof EventIndoorComponent
   */
  @Input()
  date: Date;
  constructor(injector: Injector, private filter: FiltersServiceService) {
    super(injector, filter, new SeriesStageIndoorStore(injector));
  }

  ngOnInit() {
  }

  dateFrom(date: string) {
    const dateSplit = date.split('-');
    const dateFormatted = new Date();
    const year = Number(dateSplit[0]);
    const month = Number(dateSplit[1]);
    const day = Number(dateSplit[2]);
    dateFormatted.setFullYear(year);
    dateFormatted.setMonth(month);
    dateFormatted.setDate(day);
    return dateFormatted;
  }
  checkSameDay(first: Date, second: Date): boolean {
    first = new Date(first);
    second = new Date(second);
    return (
      first.getDay() === second.getDay() &&
      first.getMonth() === second.getMonth() &&
      first.getFullYear() === second.getFullYear()
    );
  }
  standartLink(value: string) {
    let normalizedURL = value;
    const valueSplitted = value.split('.');
    if (valueSplitted[0] === 'www') {
      normalizedURL = 'http://' + value;
    }
    return normalizedURL;
  }
}
